import { DISMISS_REMIND_UI } from './constants';

export const createRemindItemUiKey = remindId => `${DISMISS_REMIND_UI}_${remindId}`;
